import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {MedicalRecordVisitReasonDataService} from './impl/service/ngrx/medicalRecordVisitReasonData.service';
import {MedicalRecordVisitReasonRepository} from "./impl/service/ngrx/medicalRecordVisitReason.repository";
import {
    AI_REALTIME_TOOL_DEFINITIONS,
    AiRealtimeToolDefinition
} from '../../../ai/realtime/api/service/aiRealtime.service';

@NgModule({
    providers: [
        {
            provide: AI_REALTIME_TOOL_DEFINITIONS,
            useValue: [
                {
                    toolName: 'add_visit_reasons_to_consultation',
                    runningLabel: 'Ajout d\'un motif de consultation en cours',
                    errorLabel: 'Erreur lors de l’ajout de motifs de consultation',
                    successLabel: 'Motif(s) de consultation ajouté(s)',
                    appEventNames: ['medicalVisitReason']
                } as AiRealtimeToolDefinition],
            multi: true,
        }
    ]
})
export class MedicalRecordVisitReasonModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                dataService: MedicalRecordVisitReasonDataService,
                service: MedicalRecordVisitReasonRepository,
    ) {

        entityDataService.registerServices({
            MedicalRecordVisitReason: dataService,
        });

        entityServices.registerEntityCollectionServices({
            MedicalRecordVisitReason: service,
        });

    }
}
